import { Card, CardContent, CardHeader } from '@/common/components/Card.tsx'
import AddHelpLinkPopup from '@/pages/setup/link_handlers/help_links/components/AddHelpLinkPopup.tsx'
import {
  Command,
  CommandEmpty,
  CommandItem,
  CommandList,
} from '@/shad/ui/command.tsx'
import EditHelpLinkPopup from '@/pages/setup/link_handlers/help_links/components/EditHelpLinkPopup.tsx'
import { useSelector } from 'react-redux'
import { RootState } from '@/storage/store.ts'

interface HelpLink {
  id: number
  program_id: number
  link: string
}

interface Props {
  onHelpLinkChange: () => Promise<void>
  helpLinks: HelpLink[]
  invalidateHelpLinks: () => void
}

const HelpLinksList = (props: Props) => {
  const rol = useSelector((state: RootState) => state.auth.roles)
  const { helpLinks, invalidateHelpLinks, onHelpLinkChange } = props

  const handleCategoryChange = () => {
    if (onHelpLinkChange) {
      onHelpLinkChange()
    }
    invalidateHelpLinks()
  }

  function contains(array: string[], ...values: string[]): boolean {
    return values.some((value) => array.includes(value))
  }

  return (
    <Card>
      <CardHeader className="py-2">
        <div className="flex items-center justify-between">
          <h3 className="font-medium">Help Link</h3>
          <div>
            {contains(rol, 'admin', 'program_manager') && (
              <AddHelpLinkPopup onAddHelpLinkSuccess={handleCategoryChange} />
            )}
          </div>
        </div>
      </CardHeader>
      <CardContent className="w-full">
        <div className="w-full">
          <Command className="h-full">
            <div className="h-full w-full">
              <CommandList className="w-full h-full py-2">
                {helpLinks.length === 0 ? (
                  <CommandEmpty>No Help Links available.</CommandEmpty>
                ) : (
                  helpLinks.map((helpLink) => (
                    <CommandItem
                      className="text-gray-600  hover:text-gray-600  justify-between data-[selected=true]:text-gray-600 data-[selected=true]:bg-transparent"
                      key={helpLink.id}
                      value={helpLink.link}
                    >
                      <div>
                        <div className="font-medium text-gray-800">
                          {helpLink.link}
                        </div>
                      </div>
                      {contains(rol, 'admin', 'program_manager') && (
                        <EditHelpLinkPopup
                          helpLinks={helpLinks}
                          linkId={helpLink.id}
                          currentLink={helpLink.link}
                          onEditHelpLinkSuccess={() => {
                            invalidateHelpLinks()
                          }}
                        />
                      )}
                    </CommandItem>
                  ))
                )}
              </CommandList>
            </div>
          </Command>
        </div>
      </CardContent>
    </Card>
  )
}
export default HelpLinksList
